import { useQuery } from '@tanstack/react-query';
import type { WindowCombinationDto } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface CatalogueCombinationsApiResponse {
  success: boolean;
  data: WindowCombinationDto[];
}

/**
 * Hook to fetch window combinations based on cascade selection.
 * Calls GET /catalogue/combinations
 */
export function useCombinations(
  materialId?: number,
  windowTypeId?: number,
  seriesId?: number,
  typeId?: number,
  sashId?: number,
  frameStyle?: string
) {
  return useQuery({
    queryKey: queryKeys.catalogue.combinations(materialId, windowTypeId, seriesId, typeId, sashId, frameStyle),
    queryFn: async () => {
      const params: Record<string, string | number> = {
        materialId: materialId!,
        windowTypeId: windowTypeId!,
        seriesId: seriesId!,
        typeId: typeId!,
      };
      if (sashId) params.sashId = sashId;
      if (frameStyle) params.frameStyle = frameStyle;

      const response = await apiClient.get<CatalogueCombinationsApiResponse>('/catalogue/combinations', {
        params,
      });
      return response.data.data;
    },
    // We only enable this query once all mandatory cascade levels up to typeId are selected.
    enabled: !!materialId && !!windowTypeId && !!seriesId && !!typeId,
    staleTime: 5 * 60 * 1000,
  });
}
